import React from "react";
import { WishListRemoveProductBody } from "tsi-common-react/src/apps/customer-account/WishListRemoveProductBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.WishListRemoveProductDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <WishListRemoveProductBody {...props} />
    </PageSkeleton>
);
